var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLcAgendamento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "current"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_4422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6561 14.3999C15.6561 13.7679 16.1681 13.2559 16.8001 13.2559C17.4321 13.2559 17.9441 13.7679 17.9441 14.3999C17.9441 15.0319 17.4321 15.5439 16.8001 15.5439C16.1681 15.5439 15.6561 15.0319 15.6561 14.3999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6014 8.3999C13.6014 8.3999 11.1614 10.7519 11.0174 13.7119L9.48145 15.7599C9.28145 16.0239 9.47345 16.3999 9.80145 16.3999H11.0014V18.7999C11.0014 19.6799 11.7214 20.3999 12.6014 20.3999H13.4014V22.7999H19.0014V19.0559C20.8894 18.1599 22.2014 16.2319 22.2014 13.9999C22.2014 10.9039 19.6974 8.3999 16.6014 8.3999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_105_4422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4 15.7374L17.0375 15.4074C15.75 14.2399 14.9 13.4699 14.9 12.5249C14.9 11.7549 15.505 11.1499 16.275 11.1499C16.71 11.1499 17.1275 11.3524 17.4 11.6724C17.6725 11.3524 18.09 11.1499 18.525 11.1499C19.295 11.1499 19.9 11.7549 19.9 12.5249C19.9 13.4699 19.05 14.2399 17.7625 15.4099L17.4 15.7374Z",
    fill: "#6191EF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_4422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(6.40002 6.3999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_105_4422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(14.4 10.3999)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcAgendamento);
export default __webpack_public_path__ + "static/media/lcAgendamento.f4566144.svg";
export { ForwardRef as ReactComponent };